import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../../config/config';
import {
    Card, CardBody,
    CardTitle, Form, Row, FormGroup, Button, Col, Input
} from 'reactstrap';
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } 
from "../../common/renderinput";
import {Loading,LoadingDone,Reset,Success,Error, SetSearchUserData, ShowAddUser} from "../../../actions/loading"

import { connect } from 'react-redux';
import axios from 'axios';


class SearchUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addrow : false 
        };
    }
    handleSearch = (values) => {
        //Use axios to send request
        this.props.Loading();
        axios.post(
            appConfig.apiGateway.searchUrl,
            JSON.stringify({...values, "Action":"USER"}, null, 2),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.LoadingDone();
            this.props.SetSearchUserData(JSON.parse(response.data.body));
        }, error => {
            this.props.LoadingDone();
        });

        //Set loading to parent
        //if success loading false, set data
        //if error loading false display banner
    }

    render() {
        return (
            <>
                <Card className="w-100">
                    <CardBody>
                        <CardTitle>Search Criteria</CardTitle>
                        <form onSubmit={this.props.handleSubmit(this.handleSearch)}>
                            <Row form>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="Email" component={renderInput} label="Email" />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="searchUserPhoneParam" component={renderInput} label="Phone" />
                                    </FormGroup>
                                </Col>

                                <Col md={6}>
                                    <FormGroup>
                                        <Button color="primary" >Search</Button>
                                        <Button className="ml-3" >Reset</Button>
                                        <Button className="ml-3" onClick={()=> {
                                                this.props.ShowAddUser()
                                                }} >Add</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </>
        );
    }
}

const validate = (formvalues) => {
}

var sf = reduxForm({
    form: 'searchUserform',
    validate
})(SearchUserForm);
sf = connect(state => ({
    session: state.session,
    loading : state.loading
}),
{LoadingDone,Loading,Success,Error,Reset, SetSearchUserData, ShowAddUser})(sf);
export default sf;